module.exports = __webpack_public_path__ + "static/media/HoneyN'Oatmeal 100g.ac52ab9b.jpg";